import { type Euler, Quaternion, Vector3 } from "three";

/**
 * Legacy Pad mesh: `BoxGeometry` with mesh position `(0, -strength/2, 0)` in part space so the
 * part origin sits on the inner face. Move that offset into `position` in world space so the
 * renderer can keep the mesh at the origin (same convention as outer panels: position = slab center).
 */
export function applyPadVolumeCenterWorldOffset(
  position: Vector3,
  strength: number,
  rotation: Euler,
): Vector3 {
  const q = new Quaternion().setFromEuler(rotation);
  const local = new Vector3(0, -strength / 2, 0);
  local.applyQuaternion(q);
  return position.clone().add(local);
}
